module.exports = __webpack_public_path__ + "img/14.845aac30.svg";